// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const APINotSupportedForRDLError = "This API is currently not supported for RDL reports";
export const EmbedUrlNotSupported = "Embed URL is invalid for this scenario. Please use Power BI REST APIs to get the valid URL";
export const invalidEmbedUrlErrorMessage: string = "Invalid embed URL detected. Either URL hostname or protocol are invalid. Please use Power BI REST APIs to get the valid URL";

